import React, { useState, useEffect } from "react";
import Footer from "../Global/Footer";
import Header from "../Global/Header";
import { ethers } from "ethers";
import { useStateValue } from "../StateProvider";
import erc20abi from "./ERC721abi.json";

function Mint() {
  const [{ global }] = useStateValue();
  const [contractListened, setContractListened] = useState();
  const [txStatus, settxStatus] = useState("");
  const [error, setError] = useState();
  const [tx, set_tx] = useState(0);

  const [num, setNum] = useState(2);

  const decrement = () => {
    if (num <= 1) {
      setNum(1);
    } else {
      setNum(num - 1);
    }
  };
  const increment = () => {
    if (num >= 10) {
      setNum(10);
    } else {
      setNum(num + 1);
    }
  };

  const [contractInfo, setContractInfo] = useState({
    address: "0xAc49336C40b532e6B198B939C2296950d03aEcBF",
    tokenName: "-",
    tokenSymbol: "-",
    totalSupply: "-",
    maxSupply: "-",
    cost: "-",
  });
  async function fetchTransaction(tx) {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    let txn_test = await provider.getTransactionReceipt(tx);
    if (txn_test) {
      if (txn_test.status === 0) {
        setError(1);
        set_tx(tx);
      }
    }
  }
  async function handleSubmit() {
    // if (parseInt(global.networkId) === 1) {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const erc20 = new ethers.Contract(
      "0xAc49336C40b532e6B198B939C2296950d03aEcBF",
      erc20abi,
      provider
    );
    const tokenName = await erc20.name();
    const tokenSymbol = await erc20.symbol();
    const totalSupply = await erc20.totalSupply();
    const maxSupply = await erc20.maxSupply();
    let cost = await erc20.cost();
    cost = ethers.utils.formatEther(String(cost));

    setContractInfo({
      address: "0xAc49336C40b532e6B198B939C2296950d03aEcBF",
      tokenName,
      tokenSymbol,
      totalSupply,
      maxSupply,
      cost,
    });
    // }
  }
  useEffect(() => {
    // if (parseInt(global.networkId) !== 1) {
    //     setError("Change your network to Mainnet.");
    //     return false;
    // } else if (parseInt(global.networkId) === 1) {
    //     setError("");
    //     handleSubmit();
    //     if (contractInfo.address !== "-") {
    //         const provider = new ethers.providers.Web3Provider(window.ethereum);
    //         const erc20 = new ethers.Contract(
    //         contractInfo.address,
    //         erc721abi,
    //         provider
    //         );
    //         setContractListened(erc20);
    //     }
    // }
    setError("");
    // handleSubmit();
    // if (contractInfo.address !== "-") {
    //   const provider = new ethers.providers.Web3Provider(window.ethereum);
    //   const erc20 = new ethers.Contract(
    //     contractInfo.address,
    //     erc20abi,
    //     provider
    //   );
    //   setContractListened(erc20);
    // }
  }, [contractInfo, global.networkId]);

  const mintToken = async () => {
    setError("");
    settxStatus("processing");
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    await provider.send("eth_requestAccounts", []);
    const signer = await provider.getSigner();
    const erc20 = new ethers.Contract(contractInfo.address, erc20abi, signer);
    //await erc20.mint(1, { gasLimit: 3000000, mint: "0.01 ETH" });
    await erc20
      .mint(1, {
        gasLimit: 246078,
        value: ethers.utils.parseEther(contractInfo.cost),
      })
      .then((tx) => {
        console.log(tx);
        //action prior to transaction being mined
        provider.waitForTransaction(tx.hash).then(() => {
          //action after transaction is mined
          console.log(`Transaction hash: ${tx.hash}`);
          fetchTransaction(tx.hash);
          settxStatus("completed");
          handleSubmit();
          // (async (tx) => {
          //   const receipt = await tx.wait();
          //   console.log(
          //     `Transaction confirmed in block ${receipt.blockNumber}`
          //   );
          //   console.log(`Gas used: ${receipt.gasUsed.toString()}`);
          // })();
        });
      })
      .catch(() => {
        console.log("tx rejected");
        settxStatus("rejected");
        setError("Transaction rejected.");
      });
  };
  return (
    <>
      <div id="main_banner" className="container-fluid mint-banner">
        <Header />
        <div className="row">
          <h2 className="heading main_banner-heading minting_heading">
            Little Billionaires <span className="pre_sale">Presale</span>
          </h2>
          {/* <p className="para-sub main_banner-para">
            Enter the world of billionaires and benefit from staking your NFT,
            earning <br />
            $LITTLE and MATIC on a daily basis and countless other utilities and
            benefits
          </p> */}

          <div className="col-sm-6">
            <center>
              <div className="mint-card">
                <h2 className="mint-head">Mint NFT</h2>
                <p className="mint-para">7,777 NFTs</p>

                <div className="amount">
                  <ul className="amount_list">
                    <li>
                      <p className="amount_p">Amount</p>
                    </li>
                    <li>
                      <span>
                        <span className="decrement" onClick={decrement}>
                          -
                        </span>
                      </span>
                      <span className="number">{num}</span>

                      <span>
                        <span className="increment" onClick={increment}>
                          +
                        </span>
                      </span>
                    </li>

                    <li>
                      <button
                        onClick={() => {
                          setNum(10);
                        }}
                        className="max"
                      >
                        MAX
                      </button>
                    </li>
                  </ul>
                </div>

                <div className="amount new_list">
                  <ul className="amount_list">
                    <li>
                      <p className="amount_p">Total</p>
                    </li>
                    <li></li>

                    <li>
                      <p className="amount_p">0.08 ETH</p>
                    </li>
                  </ul>
                </div>

                <div className="mint_button">
                  <button className="minting discord-btn">MINT</button>

                  <p className="metamask">
                    Make sure your Metamask wallet is connected
                  </p>
                </div>
              </div>
            </center>
          </div>

          <div className="col-sm-6 mint-image">
            <img className="mint-img" src={"images/mint.png"} />
          </div>

          <ul
            className="price-phrase main_banner-list main_banners d-none"
            style={{ paddingTop: 0,display:"none" }}
          >
            <li>
              {contractInfo.totalSupply !== "" && (
                <h3>
                  {String(contractInfo.totalSupply)}/
                  {String(contractInfo.maxSupply)}
                </h3>
              )}
              {(txStatus === "completed" ||
                txStatus === "" ||
                txStatus === "rejected") && (
                <button
                  className="custom-btn btn-banner header discord-btn"
                  onClick={mintToken}
                >
                  Mint Now
                </button>
              )}
              {error !== "" && error !== 1 && (
                <div style={{ color: "#dc3545" }}>{error}</div>
              )}
              {txStatus === "processing" && txStatus !== "" && (
                <img src="images/loading.gif" height="80px" alt="Loader gif" />
              )}

              {error === 1 && (
                <div style={{ color: "red", marginTop: "8px" }}>
                  Transaction failed.
                  <a
                    href={"https://rinkeby.etherscan.io/tx/" + tx}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "blue" }}
                  >
                    Please follow this link
                  </a>
                  to view in detail.
                </div>
              )}
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </>
  );
}
export default Mint;
